// extracted by mini-css-extract-plugin
module.exports = {"root":"b1ddd01198--root--m2tpo","description":"b1ddd01198--description--iiO4N"};